import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const WhyChooseSection = () => {
  return (
    <section className="section" id="why" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center"
        >
          <span className="caption mb-4 inline-block" style={{ color: 'var(--accent-primary)' }}>
            Why Us
          </span>
          <h2 className="heading-1 mb-12">Why Strategy Intelligence Solutions</h2>

          <div className="grid sm:grid-cols-2 gap-4 text-left">
            {whyChooseUs.map((reason, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="card flex items-start gap-4"
              >
                <div 
                  className="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{ 
                    background: 'var(--accent-subtle)',
                    border: '1px solid var(--border-accent)'
                  }}
                >
                  <Check size={14} style={{ color: 'var(--accent-primary)' }} />
                </div>
                <span className="body-medium" style={{ color: 'var(--text-primary)' }}>{reason}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
